import React, { memo } from 'react';
import useAuth from 'src/hooks/useAuth';
import SelectLanguage from './SelectLanguage';

interface INavBar {
  title: string;
}

const Navbar: React.FC<INavBar> = ({ title }) => {
  const { isShuster } = useAuth();

  return (
    <nav className={`h-9 shadow-md  px-2 ${isShuster ? 'bg-[#676767]' : 'bg-[#94c947]'}`}>
      <div className="flex justify-between items-center">
        <div className="ml-2">
          <p className="text-white font-bold text-xl">{title}</p>
        </div>
        <SelectLanguage />
      </div>
    </nav>
  );
};

export default memo(Navbar);
